import { useState } from "react";
import { Clock, CheckCircle, DollarSign, TrendingUp } from "lucide-react";

const StatsGrid = ({ t, styles, stats, language }) => {
  const [hoveredCard, setHoveredCard] = useState(null);
  const totalAmountFormatted =
    language === "ar"
      ? `${stats.totalAmount.toLocaleString("ar-EG")} ج.م`
      : `EGP ${stats.totalAmount.toLocaleString()}`;

  return (
    <>
      <style>{`
        @keyframes slideUpFade {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .stat-card-animated {
          animation: slideUpFade 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
          opacity: 0;
          transition: all 0.3s ease;
        }

        .stat-card-animated:hover {
          transform: translateY(-8px) scale(1.02);
          box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2) !important;
        }

        .stat-card-1 { animation-delay: 0.1s; }
        .stat-card-2 { animation-delay: 0.2s; }
        .stat-card-3 { animation-delay: 0.3s; }
        .stat-card-4 { animation-delay: 0.4s; }
      `}</style>

      <div style={styles.statsGrid}>
        {/* Pending */}
        <div
          className="stat-card-animated stat-card-1"
          style={{
            ...styles.statCard,
            transform: hoveredCard === 1 ? "translateY(-8px) scale(1.02)" : "translateY(0)",
            transition: "all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
          }}
          onMouseEnter={() => setHoveredCard(1)}
          onMouseLeave={() => setHoveredCard(null)}
        >
          <div style={styles.statIcon}>
            <Clock size={24} color="white" />
          </div>
          <div style={styles.statInfo}>
            <p style={styles.statValue}>{stats.totalPending}</p>
            <p style={styles.statLabel}>{t.pendingRequests}</p>
          </div>
        </div>

        {/* Approved */}
        <div
          className="stat-card-animated stat-card-2"
          style={{
            ...styles.statCard,
            transform: hoveredCard === 2 ? "translateY(-8px) scale(1.02)" : "translateY(0)",
            transition: "all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
          }}
          onMouseEnter={() => setHoveredCard(2)}
          onMouseLeave={() => setHoveredCard(null)}
        >
          <div
            style={{
              ...styles.statIcon,
              background: "linear-gradient(135deg, #10b981, #059669)",
            }}
          >
            <CheckCircle size={24} color="white" />
          </div>
          <div style={styles.statInfo}>
            <p style={styles.statValue}>{stats.totalApproved}</p>
            <p style={styles.statLabel}>{t.approved}</p>
          </div>
        </div>

        {/* Disbursed */}
        <div
          className="stat-card-animated stat-card-3"
          style={{
            ...styles.statCard,
            transform: hoveredCard === 3 ? "translateY(-8px) scale(1.02)" : "translateY(0)",
            transition: "all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
          }}
          onMouseEnter={() => setHoveredCard(3)}
          onMouseLeave={() => setHoveredCard(null)}
        >
          <div
            style={{
              ...styles.statIcon,
              background: "linear-gradient(135deg, #8b5cf6, #7c3aed)",
            }}
          >
            <DollarSign size={24} color="white" />
          </div>
          <div style={styles.statInfo}>
            <p style={styles.statValue}>{stats.totalDisbursed}</p>
            <p style={styles.statLabel}>{t.disbursed}</p>
          </div>
        </div>

        {/* Total Amount */}
        <div
          className="stat-card-animated stat-card-4"
          style={{
            ...styles.statCard,
            transform: hoveredCard === 4 ? "translateY(-8px) scale(1.02)" : "translateY(0)",
            transition: "all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
          }}
          onMouseEnter={() => setHoveredCard(4)}
          onMouseLeave={() => setHoveredCard(null)}
        >
          <div
            style={{
              ...styles.statIcon,
              background: "linear-gradient(135deg, #f59e0b, #d97706)",
            }}
          >
            <TrendingUp size={24} color="white" />
          </div>
          <div style={styles.statInfo}>
            <p style={styles.statValue}>{totalAmountFormatted}</p>
            <p style={styles.statLabel}>{t.totalAmount}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatsGrid;